module.exports = __webpack_public_path__ + "static/img/body-bg.20cbb7c.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/image/body-bg.jpg
// module id = 3nZG
// module chunks = 1